export default class Collection {
  constructor() {

  }

  /**
   * @param item{*}
   * @return {boolean}
   */
  add(item) {
    throw new Error('Not implemented');
  }

  /**
   *
   * @param item
   * @return {boolean}
   */
  contains(item) {
    throw new Error('Not implemented');
  }

  /**
   *
   * @param item{*}
   * @return {*}
   */
  remove(item) {
    throw new Error('Not implemented');
  }

  /**
   *
   * @param collection{Collection}
   */
  addAll(collection) {
    throw new Error('Not implemented');
  }

  /**
   *
   * @param jsonArray{Array}
   */
  addArray(jsonArray) {
    throw new Error('Not implemented');
  }

  clear() {
    throw new Error('Not implemented');
  }

  /**
   * @return {number}
   */
  size() {
    throw new Error('Not implemented');
  }

  /**
   * return {Array}
   */
  toArray() {
    throw new Error('Not implemented');
  }

  /**
   * @return {Iterator}
   */
  iterator() {
    throw new Error('Not implemented');
  }
}